import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Typography, Box } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Edit } from "../../../../assets/AccountingModule/uil_edit.svg";
import { ReactComponent as RemoveRedEyeOutlinedIcon } from "../../../../assets/AccountingModule/view.svg";
import styles from "./style";
import CustomPagination from "../../../../components/CustomPagination";
import Modal from "../../../../components/Modal";
import { Data } from "../../../../constants/data"

const ItemsList = ({ data, totalCount, handleDelete, page, setPage }) => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState();
  const navigate = useNavigate()

  const handleNavigate = (item) => {
    navigate("/dashboard/editItem", { state: { item } })
  }
  const handleNavigateView = (item) => {
    navigate("/dashboard/viewItem", { state: { item } })
  }

  const deleteData = (item) => {
    setValue(item);

  }
  const handleDeleteItem = () => {
    handleDelete(value);
    setOpen(false); // Close the modal after deleting
  };

  return (
    <>
      <TableContainer sx={styles.noShadow}>
        <Table  >
          <TableHead>
            <TableRow>
              <TableCell sx={styles.tableHead}>#</TableCell>
              <TableCell sx={styles.tableHead}>Product Name</TableCell>
              <TableCell sx={styles.tableHead}>Active Status</TableCell>
              <TableCell sx={styles.tableHead}>Category</TableCell>
              <TableCell sx={styles.tableHead}>Quantity</TableCell>
              <TableCell sx={styles.tableHead}>Purchase Price</TableCell>
              <TableCell sx={styles.tableHead}>Selling Price</TableCell>
              <TableCell sx={styles.tableHead}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              data?.map((item, index) => {
                return (<TableRow key={index} sx={{ verticalAlign: "baseline" }}>
                  <TableCell sx={styles.tabledata}>{index + 1} </TableCell>
                  <TableCell sx={styles.tabledata}>{item?.title?.length > 15 ? `${item?.title?.slice(0, 15)}...` : item?.title}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.isActive ? "Active" : "Inactive"}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.category > 15 ? `${item?.category?.slice(0, 15)}...` : item?.category}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.quantity}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.purchasePrice.toFixed(2)}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.sellingPrice.toFixed(2)}</TableCell>
                  <TableCell sx={styles.actionData}>
                    <Box onClick={() => handleNavigate(item)} sx={{ cursor: "pointer" }}><Edit /></Box>
                    <Box onClick={() => handleNavigateView(item)} sx={{ mx: 2.5, cursor: "pointer" }}><RemoveRedEyeOutlinedIcon /></Box>
                    <Box onClick={() => { deleteData(item?._id), setOpen(true); }}><DeleteOutlineIcon sx={{ color: "#ff0000", cursor: "pointer" }} /></Box>
                  </TableCell>
                </TableRow>);
              })
            )}
          </TableBody>
        </Table>
        {Data &&
          <CustomPagination
            pageCount={totalCount}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            totalItems={Data?.length}
          />}
      </TableContainer>
      <Modal open={open} setOpen={setOpen} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Item"} handleDelete={handleDeleteItem}>
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>
    </>);
};
export default ItemsList;
